import React, { useEffect, useState } from 'react';
import { SendOutlined, WarningOutlined } from '@ant-design/icons';
import { App, Card, Divider, Progress, Select, Space, theme, Typography } from 'antd';
import { generate } from '@ant-design/colors';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var RoundItem = models.rounds.RoundItem;
var RoundTeamSource = models.teams.RoundTeamSource;
var ClassesSource = models.classes.ClassesSource;
var TeamSource = models.teams.TeamSource;
var ClassItem = models.classes.ClassItem;
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
const { Title } = Typography;
const { useToken } = theme;
export const CopyTeamsClass = (props) => {
    const { round, disabled } = props;
    const { notification } = App.useApp();
    const [teams, loadingTeams] = Stream(RoundTeamSource(round.round_id));
    const [classes, loadingClasses] = Stream(ClassesSource(round.competition_id));
    const { token } = useToken();
    const [progress, setProgress] = useState(0);
    const [selectedClassId, setSelectedClassId] = useState(null);
    const teamURL = TeamSource(round.competition_id).url;
    const settings = RoundItem.getPrioritySettings(round);
    const groups = settings.groups;
    const hasGroups = !!(groups && groups.length > 0);
    const selectedClass = classes === null || classes === void 0 ? void 0 : classes.find(a => a.class_id === selectedClassId);
    const primaryColorShades = generate(token.colorPrimary, { theme: 'default' });
    const groupColors = groups && groups.map((_, index) => {
        const shadeIndex = Math.floor((index / groups.length) * primaryColorShades.length);
        return primaryColorShades[shadeIndex];
    });
    useEffect(() => {
        setProgress(0);
        setSelectedClassId(null);
    }, [round.round_id]);
    const onSendTeams = async (done) => {
        setProgress(0);
        let createTeams = [];
        if (hasGroups) {
            // Populate createTeams array
            groups && groups.forEach((group, index) => {
                const targetClass = classes === null || classes === void 0 ? void 0 : classes.find(a => a.class_id === group.class_id);
                const groupTeams = teams === null || teams === void 0 ? void 0 : teams.filter(a => !a.team_cancelled && a.heats_team_priority === index);
                if (targetClass) {
                    groupTeams === null || groupTeams === void 0 ? void 0 : groupTeams.forEach(team => {
                        const newTeam = {
                            ...team,
                            class_id: group.class_id,
                            team_class: ClassItem.getClassLabel(targetClass),
                            team_placement: '',
                            team_sum: '',
                            team_id: null
                        };
                        createTeams.push(newTeam);
                    });
                }
            });
        }
        else if (selectedClass) {
            const groupTeams = teams === null || teams === void 0 ? void 0 : teams.filter(a => a.heats_team_priority != null);
            groupTeams === null || groupTeams === void 0 ? void 0 : groupTeams.forEach(team => {
                var _a, _b;
                const priority = (_a = team.heats_team_priority) !== null && _a !== void 0 ? _a : 0;
                const alternateComment = _T('round.details.round_num_alternates.level', { value: priority });
                const existingComment = (_b = team.team_note) === null || _b === void 0 ? void 0 : _b.trim();
                const newTeam = {
                    ...team,
                    class_id: selectedClass.class_id,
                    team_class: ClassItem.getClassLabel(selectedClass),
                    team_cancelled: priority > 0 ? true : team.team_cancelled,
                    team_note: priority > 0
                        ? (existingComment ? `${existingComment} - ${alternateComment}` : alternateComment)
                        : existingComment,
                    team_placement: '',
                    team_sum: '',
                    team_id: null
                };
                createTeams.push(newTeam);
            });
        }
        // Total teams to create
        const totalTeams = createTeams.length;
        // Iterate through teams
        let errorsFound = 0;
        for (let i = 0; i < totalTeams; i++) {
            const newTeam = createTeams[i];
            try {
                await Api.create(teamURL, newTeam);
            }
            catch (err) {
                errorsFound++;
                notification.error({
                    message: err.message,
                });
            }
            const progressValue = Math.floor(((i + 1) / totalTeams) * 100);
            setProgress(progressValue);
        }
        if (!errorsFound) {
            notification.success({
                message: _T('round.details.priority.sendSuccess')
            });
        }
        done();
    };
    return (React.createElement(Card, { title: React.createElement(React.Fragment, null,
            React.createElement(SendOutlined, null),
            " ",
            _T('round.details.priority.send')), loading: loadingTeams || loadingClasses },
        React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
            hasGroups && groups && groups.map((group, index) => {
                const groupCount = teams === null || teams === void 0 ? void 0 : teams.filter(a => !a.team_cancelled && a.heats_team_priority === index).length;
                const targetClass = classes === null || classes === void 0 ? void 0 : classes.find(a => a.class_id === group.class_id);
                return (React.createElement("div", { key: index, style: {
                        padding: '8px',
                        border: `1px solid ${groupColors[index]}`,
                        borderRadius: '4px',
                        backgroundColor: `${groupColors[index]}20`,
                    } },
                    React.createElement(Title, { level: 5, style: { margin: 0 } },
                        targetClass ?
                            (targetClass === null || targetClass === void 0 ? void 0 : targetClass.class_label) || (targetClass === null || targetClass === void 0 ? void 0 : targetClass.class_name)
                            :
                                React.createElement(Space, null,
                                    React.createElement(WarningOutlined, null),
                                    _T('class.error.not-found')),
                        React.createElement(Divider, { orientation: 'vertical' }),
                        group.name,
                        " - ",
                        groupCount)));
            }),
            !hasGroups && (React.createElement(Select, { placeholder: _T('common.select', { name: _T('class.title').toLowerCase() }), value: selectedClassId !== null && selectedClassId !== void 0 ? selectedClassId : undefined, onChange: value => setSelectedClassId(value), style: { width: '100%' }, size: 'large' }, classes === null || classes === void 0 ? void 0 : classes.map(classItem => (React.createElement(Select.Option, { value: classItem.class_id, key: classItem.class_id }, ClassItem.getClassLabel(classItem)))))),
            React.createElement(ButtonConfirm, { title: _T('round.details.priority.send'), description: _T('common.confirm'), onConfirm: done => onSendTeams(done), buttonProps: {
                    type: 'primary',
                    size: 'large',
                    icon: React.createElement(SendOutlined, null),
                    disabled: disabled || (!hasGroups && !selectedClassId)
                } }),
            progress > 0 &&
                React.createElement(Progress, { percent: progress, status: progress < 100 ? 'active' : undefined }))));
};
